import { render, staticRenderFns } from "./DataToProvide.vue?vue&type=template&id=dbb3d0de&scoped=true&"
import script from "./DataToProvide.vue?vue&type=script&lang=js&"
export * from "./DataToProvide.vue?vue&type=script&lang=js&"
import style0 from "./DataToProvide.vue?vue&type=style&index=0&id=dbb3d0de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb3d0de",
  null
  
)

export default component.exports